var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C23.2843 0 30 6.71335 30 14.9947C30 22.479 24.5147 28.6823 17.3438 29.8072V19.3291H20.8389L21.5039 14.9947H21.4316L21.4388 14.9474H17.3438V12.1819C17.3438 10.9961 17.9249 9.84027 19.7882 9.84027H21.6797V6.15017C21.6797 6.15017 21.6572 6.14633 21.615 6.13954V6.06937C21.615 6.06937 19.895 5.77539 18.2507 5.77539C14.8176 5.77539 12.5739 7.85909 12.5739 11.6314V14.9474H8.75781V19.2983H8.84766V19.3291H12.5739V29.7941C5.44331 28.6347 0 22.4503 0 14.9947C0 6.71335 6.71572 0 15 0Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d7283e39ae86b6ebb97ad29b9d031afd.svg";
export { ForwardRef as ReactComponent };